// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"762":"5f42fbf5","787":"bfaad7ea","942":"4aa9966d"}[chunkId] + ".chunk.js";
};